import {PhonenumberFilter} from './PhonenumberFilter';
import {WordFilter} from './WordFilter';
import {TrustAsHtml} from './TrustAsHtml';
import {RemoveTags} from './RemoveTags';
import {HighlightMatchingWords} from './HighlightMatchingWords';

export default angular.module('searchEngineFrontend.app.shared.filters', [])
    .filter('phonenumber', PhonenumberFilter)
    .filter('words', WordFilter)
    .filter('trustAsHtml', TrustAsHtml)
    .filter('removeTags', RemoveTags)
    .filter('highlightWords', HighlightMatchingWords);


// WEBPACK FOOTER //
// ./src/app/shared/filters/index.js